import { fontSizes } from "@oneleet/config/constants";

import { extendTailwindMerge } from "tailwind-merge";

// Extend the default tailwind merge config to prevent our custom text-ng- font size class names from being overridden by text- color class names.
// Required for custom font sizes to work with tailwind merge.
//
// See these threads:
// https://github.com/dcastil/tailwind-merge/issues/276
// https://github.com/epicweb-dev/epic-stack/issues/301
//
// We named our custom tailwind merge function "cn" as it's become a common convention from projects like shadcn, but also to make it obvious
// where we're using our new custom tailwind merge function versus the default tailwind merge function.
//
// See this thread for why we don't include clsx/don't support using object syntax for class names:
// Long story short: It's easier/clearer to read and more performant
// https://github.com/dcastil/tailwind-merge/discussions/137#discussioncomment-3481605
export const cn = extendTailwindMerge({
  extend: {
    classGroups: {
      "font-size": Object.keys(fontSizes).map((key) => `text-${key}`),
    },
  },
});
